/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PrueflaufIdentifier { 
    pruefplan_id?: string;
    prueflauf_id: string;
    pruefaufgabe_id?: string;
    veranstaltung_id?: string;
    mandant_id: string;
    modified_on_utc: Date;
}

